<template>
  <div class="">
    <div class="flex justify-center flex-1">
      <svg
        class="w-16 h-16 text-custom-green animate-spin"
        xmlns="http://www.w3.org/2000/svg"
        v-if="isLoading"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
    </div>
    <div v-if="!isLoading" class="flex flex-col gap-10 md:flex-row">
      <div class="w-full p-6 bg-white rounded shadow md:w-1/3 lg:w-1/4">
        <div class="flex flex-col items-center justify-center">
          <template v-if="profile?.photo_url">
            <img
              :src="profile?.photo_url"
              class="object-cover object-center w-40 h-40 rounded-full"
            />
          </template>
          <img
            v-else
            src="../assets/default_profile.png"
            class="rounded-full"
          />

          <div class="flex flex-col items-center w-full my-4">
            <h3 class="text-2xl font-bold capitalize">
              {{ profile?.first_name }} {{ profile?.last_name }}
            </h3>
            <p>{{ profile?.bio }}</p>
          </div>
          <div
            class="
              flex
              justify-center
              flex-1
              w-full
              p-4
              mb-4
              bg-gray-100
              rounded-sm
            "
          >
            <p class="text-xl font-bold text-gray-800 uppercase">About</p>
          </div>
          <div class="flex flex-col w-full my-4 rounded-sm">
            <p class="text-xl font-bold text-gray-800">Number</p>
            <p class="mb-4">{{ profile?.phone_number || 'N/A' }}</p>
            <p class="text-xl font-bold text-gray-800">Address</p>
            <p class="">
              {{ profile?.address_line_1 }}, {{ profile?.address_line_1 }},
              {{ profile?.city }}, {{ profile?.province }} -
              <span class="uppercase"> {{ profile?.postal_code }}</span>
            </p>
            <button
              @click="logout"
              type="button"
              class="
                px-6
                py-2.5
                mt-10
                mb-2
                text-xl
                font-semibold
                tracking-wide
                text-white
                uppercase
                rounded-sm
                shadow
                bg-custom-green-dark
              "
            >
              Logout
            </button>
            <button
              @click="showDeleteConfirmation"
              type="button"
              class="
                px-6
                py-2.5
                mt-10
                mb-2
                text-xl
                font-semibold
                tracking-wide
                text-white
                uppercase
                rounded-sm
                shadow
                bg-red-600
                hover:bg-red-700
              "
            >
              Delete Profile
            </button>
          </div>
        </div>
      </div>
      <div class="w-full p-6 bg-white rounded shadow md:w-2/3 lg:w-3/4">
        <h3 class="mb-5 text-2xl font-bold uppercase">Service Provider Profile</h3>
        <ServiceProviderProfileForm @profileUpdate="profileUpdate" />
      </div>
    </div>

    <!-- Delete Confirmation Modal -->
    <div v-if="showDeleteModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div class="w-full max-w-md p-6 bg-white rounded-lg shadow-xl">
        <h3 class="mb-4 text-xl font-bold text-red-600">Delete Profile</h3>
        <p class="mb-4 text-gray-700">Are you sure you want to delete your profile? This action cannot be undone.</p>

        <div class="mb-4">
          <label class="block mb-2 text-sm font-medium text-gray-700">Reason (optional)</label>
          <textarea
            v-model="deleteReason"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
            rows="3"
            placeholder="Please provide a reason for deletion..."
          ></textarea>
        </div>

        <div class="flex justify-end space-x-3">
          <button
            @click="cancelDelete"
            class="px-4 py-2 text-gray-600 bg-gray-200 rounded-md hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            @click="confirmDelete"
            class="px-4 py-2 text-white bg-red-600 rounded-md hover:bg-red-700"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ServiceProviderProfileForm from '@/components/ServiceProviderProfileForm.vue'
import { ref } from '@vue/reactivity'
import { onMounted } from '@vue/runtime-core'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import DataService from '@/services/data.service'

export default {
  components: { ServiceProviderProfileForm },

  setup () {
    const store = useStore()
    const router = useRouter()
    const profile = ref(null)
    const servicesList = ref([])
    const isLoading = ref(true)
    const showDeleteModal = ref(false)
    const deleteReason = ref('')
    const isDeleting = ref(false)

    // const mapServices = (service) => {
    //   return service
    // }
    onMounted(async () => {
      await store.dispatch('data/getProfile')
      await store.dispatch('data/getServices')
      isLoading.value = false
      profile.value = await store.state.data.profile
      const servicesData = await store.state.data.services
      for (const key in servicesData) {
        if (Object.hasOwnProperty.call(servicesData, key)) {
          const categories = servicesData[key]
          for (const key in categories) {
            if (Object.hasOwnProperty.call(categories, key)) {
              const category = categories[key]
              if (
                profile.value !== undefined &&
                profile.value.services !== undefined
              ) {
                console.log(profile.value)
                if (profile.value.services.includes(category.id)) {
                  servicesList.value.push(category)
                }
              }
            }
          }
        }
      }
    })

    const logout = async () => {
      await store.dispatch('auth/logout').then(
        () => {
          router.push({
            name: 'Login'
          })
        },
        (error) => {
          console.error(error)
        }
      )
    }

    const profileUpdate = async () => {
      console.log('profile update called')
      profile.value = await store.state.data.profile
    }

    const showDeleteConfirmation = () => {
      showDeleteModal.value = true
    }

    const cancelDelete = () => {
      showDeleteModal.value = false
      deleteReason.value = ''
    }

    const confirmDelete = async () => {
      if (isDeleting.value) return

      isDeleting.value = true
      try {
        const requestData = {
          confirm_deletion: true
        }

        // Only add reason if it has a value
        if (deleteReason.value && deleteReason.value.trim()) {
          requestData.reason = deleteReason.value.trim()
        }

        await DataService.deleteProfile(requestData)

        // Logout after successful deletion
        await store.dispatch('auth/logout')
        router.push({
          name: 'Login'
        })
      } catch (error) {
        console.error('Error deleting profile:', error)
        alert('Failed to delete profile. Please try again.')
      } finally {
        isDeleting.value = false
        showDeleteModal.value = false
        deleteReason.value = ''
      }
    }

    return {
      profile,
      isLoading,
      servicesList,
      logout,
      profileUpdate,
      showDeleteModal,
      deleteReason,
      isDeleting,
      showDeleteConfirmation,
      cancelDelete,
      confirmDelete
    }
  }
}
</script>
